import { useContext, useRef } from 'react'
import Draggable from 'react-draggable'
import ColorIcon from './ColorIcon'
import { stateContext } from './ctx'
import {deepCopy, hueAlterColor} from './functions'

const Dot = ({width,height,parent,idx}) => {
    const {schema,setSchema,hue} = useContext(stateContext)
    const nodeRef = useRef(null)
    const ob = schema[idx];

    const getPosition = () => {
        let x = (width*ob.p[0])/100
        let y = (height*ob.p[1])/100
        return {x,y}
    }

    const handleDrag = e => {
		
        const {top,left} = parent.getBoundingClientRect()
		let xPos = (e.pageX) - left;
		let yPos = (e.pageY) - top;
			xPos = parseInt(((xPos))/parent.clientWidth*100);
			yPos = parseInt(((yPos))/parent.clientHeight*100);
			xPos = (xPos < 0) ? 0 : xPos;
			xPos = (xPos > 100) ? 100 : xPos;
			yPos = (yPos < 0) ? 0 : yPos;
			yPos = (yPos > 100) ? 100 : yPos;
        const newSchema = deepCopy(schema)
        newSchema[idx].p = [xPos,yPos]
        setSchema(newSchema)
		
		
	}


    return <Draggable nodeRef={nodeRef} axis='none' position={getPosition()} bounds="parent" onDrag={handleDrag}>
        <div ref={nodeRef} className='absolute h-0 w-0 bg-yellow-100'>
            <div className='absolute w-6 h-6 rounded-full -m-3 shadow-md'>
            <ColorIcon w={6} r='full' value={hueAlterColor(ob.c,hue)} />    
            </div>   
        </div>
    </Draggable>
}

export default Dot;